import React, { useEffect } from 'react';
import { useRoutes as useRegularRoutes } from 'react-router-dom';
import { wrapUseRoutesV6 } from '@sentry/react';

import { appRoutes } from './AppRoutes';
import { useApplyAppInterceptor } from './useApplyAppInterceptor';
import { ImpersonationBanner } from '@/features/impersonation';
import { persistPartnerRefFromUrl } from '@/shared/utils/partnerRef';

const useRoutes =
  import.meta.env.MODE === 'development'
    ? wrapUseRoutesV6(useRegularRoutes)
    : useRegularRoutes;

export const App = (): JSX.Element => {
  const element = useRoutes(appRoutes);

  useApplyAppInterceptor();

  useEffect(() => { persistPartnerRefFromUrl() }, [])

  useEffect(() => {
    console.log('🐙 Git информация о сборке:');
    console.log('📍 Тег:', import.meta.env.VITE_GIT_TAG);
    console.log('🔑 Коммит:', import.meta.env.VITE_GIT_COMMIT);
    console.log('🌿 Ветка:', import.meta.env.VITE_GIT_BRANCH);
    console.log('🕐 Время сборки:', import.meta.env.VITE_BUILD_TIME);
  }, []);

  return (
    <div>
      <ImpersonationBanner />
      {element}
    </div>
  );
};
